import ApiCallThunkCreator from 'dux/api/api_call_thunk_creator'

export function getOptimizedOrganizationsAsync(options = {}) {
  return ApiCallThunkCreator.get('/optimized-organizations', null, options)
}
